import PropTypes from "prop-types";
import { State } from 'react-powerplug'
import styled from 'styled-components'
import { COLUMN_WIDTH, PADDING_LEFT } from "./constants";
import TableLabel from './TableLabel'
import TableRow from './TableRow'

const StyledTable = styled.div`
  --etb-scrollbar-size: 3px;
  width: 100%;
  overflow-x: auto;
  overflow-y: hidden;
  scrollbar-width: thin;

  &::-webkit-scrollbar {
    width: 3px;
    height: 3px;
  }

  * { box-sizing: border-box; }

  .etb-table-content {
    width: 100%;
  }

  .etb-row-group:first-child {
    .etb-row-labels {
      .etb-values {
        .etb-column-optimization {
          border-top: none;

        }
      }
    }
  }

  .etb-row-labels {
    font-size: 0.7rem;
    color: #9ba2ac;
    background: var(--color-contrast-white);
    padding: 7px 0;
    border-bottom: 1px solid var( --color-neutral-background);
    padding-left: ${PADDING_LEFT}px;
    padding-right: var(--etb-scrollbar-size);
  }

  .content-expandable-table-optimization {
    height: calc(100vh - 275px);
    overflow-x: hidden;
    overflow-y: auto;
    scrollbar-gutter: stable;
    background: #f2faff;
  }

  @media (max-width: 768px) {
    .etb-row-labels {
      padding-top: 5px;
      padding-bottom: 5px;
    }

    .content-expandable-table-optimization {
      height: calc(100vh - 235px);
    }

  }

  .content-expandable-table-optimization .etb-children {
    background: var(--color-contrast-white);
  }

  .etb-column {
    display: flex;
    align-items: center;
    flex: 1 0 ${COLUMN_WIDTH}px;
    padding: 10px 4px;
    box-sizing: border-box;
    font-size: 14px;
  }
`;

const getColumnTemplate = (labelsList) =>
  labelsList
    .map((label) => {
      const minWidth = Number.parseFloat(label.customStyle?.minWidth || COLUMN_WIDTH);
      const maxWidth = Number.parseFloat(label.customStyle?.maxWidth);

      return Number.isNaN(maxWidth) ? `minmax(${minWidth}px, 1fr)` : `${maxWidth}px`;
    })
    .join(" ");

const handleExpandItem = (items, setState) => code => {
  if (items.includes(code)) {
    setState(prevState => ({
      expandedItems: prevState.expandedItems.filter(c => c !== code)
    }));
  } else {
    setState(prevState => ({
      expandedItems: [...prevState.expandedItems, code]
    }));
  }
};

const Table = ({
  data,
  labelKey,
  labelsList,
  childrenKey,
  onClickItem,
  onSelectItem,
  allChecked,
  onSelectAllItens,
  showCheckbox,
  resolveValue,
  resolveTitle,
}) => (
  <State initial={{ expandedItems: [] }}>
    {({ state, setState }) => (
      <StyledTable>
        <div
          className="etb-table-content"
          style={{
            minWidth: `${labelsList.reduce(
              (totalWidth, label) =>
                totalWidth + Number.parseFloat(label.customStyle?.minWidth || COLUMN_WIDTH),
              44
            )}px`,
          }}
          >
          <TableLabel
            labelsList={labelsList}
            columnTemplate={getColumnTemplate(labelsList)}
            allChecked={allChecked}
            onSelectAllItens={onSelectAllItens}
            showCheckbox={showCheckbox}
          />
          <div className="content-expandable-table-optimization">
            {data.map((volume, index) => (
              <TableRow
                key={`${index + volume.Id}`}
                code={`${volume.Id}`}
                childrenKey={childrenKey}
                label={volume[labelKey]}
                item={volume}
                labelsList={labelsList}
                columnTemplate={getColumnTemplate(labelsList)}
                expandedItems={state.expandedItems}
                resolveValue={resolveValue}
                resolveTitle={resolveTitle}
                showCheckbox={showCheckbox}
                onClick={onClickItem}
                onSelectItem={onSelectItem}
                onExpandItem={handleExpandItem(state.expandedItems, setState)}
              >
                {volume[childrenKey]}
              </TableRow>
            ))}
          </div>
        </div>
      </StyledTable>
    )}
  </State>
);

Table.propTypes = {
  data: PropTypes.array.isRequired,
  labelKey: PropTypes.string,
  childrenKey: PropTypes.string,
  labelsList: PropTypes.array,
  expandedItems: PropTypes.array,
  resolveValue: PropTypes.func,
  resolveTitle: PropTypes.func,
  showCheckbox: PropTypes.func,
  renderCustomAlert: PropTypes.func,
  onClickItem: PropTypes.func,
  onSelectItem: PropTypes.func,
  allChecked: PropTypes.bool,
  onSelectAllItens: PropTypes.func,
  onExpandItem: PropTypes.func,
};

export default Table;
